export default __webpack_public_path__ + "static/Footer-a8352cad116ea1c8ae3fdcbcb7c387f5.png";